import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { initSentry, SentryErrorBoundary } from './lib/sentry'

// Inicializar Sentry antes de renderizar React, para capturar errores temprano
initSentry()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SentryErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="min-h-screen flex items-center justify-center bg-brand-800 text-cream-100 p-6">
          <div className="max-w-md text-center">
            <h1 className="font-display text-3xl tracking-wide mb-3">
              ALGO SE ROMPIÓ
            </h1>
            <p className="text-cream-100/80 mb-2 text-sm leading-relaxed">
              La app encontró un error inesperado. Ya estamos notificados
              automáticamente.
            </p>
            <p className="text-xs text-cream-100/50 mb-6 break-words">
              {error?.message ?? 'Error desconocido'}
            </p>
            <button
              onClick={resetError}
              className="bg-accent-500 hover:bg-accent-600 text-brand-900 font-bold text-sm px-6 py-3 rounded-xl transition-colors"
            >
              Intentar de nuevo
            </button>
            <p className="text-[11px] text-cream-100/50 mt-6">
              Si persiste, escribe a <a className="underline" href="mailto:estrategia@nextvalleyco.com">estrategia@nextvalleyco.com</a>
            </p>
          </div>
        </div>
      )}
    >
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>
)
